import type { IconData } from '@stacksjs/iconify-core'

export const webcamVideoFlat: IconData = {
  "body": "<path fill=\"#8fbffa\" d=\"M18 7.5c-4.59 0-8.242.383-10.757.77c-3.03.464-5.192 2.934-5.415 5.93c-.17 2.279-.328 5.545-.328 9.8s.158 7.521.328 9.8c.223 2.996 2.385 5.466 5.415 5.93c2.515.387 6.167.77 10.757.77s8.242-.383 10.757-.77c3.03-.464 5.192-2.934 5.415-5.93q.065-.858.123-1.902c1.81 1.084 3.965 2.209 6.3 3.087c2.519.947 5.104-.729 5.433-3.318c.24-1.882.472-4.52.472-7.667s-.233-5.785-.472-7.667c-.33-2.59-2.914-4.265-5.433-3.318c-2.335.878-4.49 2.003-6.3 3.087q-.058-1.044-.123-1.902c-.223-2.996-2.385-5.466-5.415-5.93C26.242 7.882 22.59 7.5 18 7.5\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default webcamVideoFlat
